module.exports = __webpack_public_path__ + "img/nevill_b3.f36043bf.jpg";